import { useState, useEffect, useRef } from 'react';
import request from '../../../../lib/request';
import ContentPopup from './contentPopup';

const Content = () => {
  const dialogRef = useRef(null);

  const [contents, setContents] = useState([]);
  const [contentId, setContentId] = useState(null);
  const [contentPopupOpen, setContentPopupOpen] = useState(false);

  useEffect(() => {
    getContents();
  }, []);

  const getContents = async () => {
    try {
      const { result } = await request.get('/content/collection/dashboard');
      if (result.length > 0) {
        const list = [];
        result.forEach((item) => {
          list.push(...item.contents);
        });
        setContents(list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const selectContent = (id) => {
    setContentId(id);
    handleOpenContentPopup();
  };

  const handleOpenContentPopup = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
      setContentPopupOpen(true);
    }
  };

  const handleCloseContentPopup = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
      setContentId(null);
      setContentPopupOpen(false);
    }
  };

  return contents.length > 0 ? (
    <div className='flex gap-4 pt-2 px-2 overflow-x-auto scrollbar-hidden'>
      {contents.map((content, i) => (
        <div
          key={i}
          className='flex flex-col items-center gap-2 cursor-pointer'
        >
          <div
            className='w-[70px] h-[70px] rounded-full p-[3px] bg-gradient-to-tr from-[#4ECDC4] to-[#FFD93D]'
            onClick={() => selectContent(content.id)}
          >
            <div className='rounded-full p-[2px] bg-black w-full h-full'>
              <img
                src={content.bannerUrl}
                alt={content.title}
                className='w-full h-full rounded-full border-[0.5px] border-tertiary object-cover'
              />
            </div>
          </div>
          <span className='text-xs text-white max-w-[84px] truncate text-center'>
            {content.title}
          </span>
        </div>
      ))}
      <ContentPopup
        dialogRef={dialogRef}
        closeDialog={handleCloseContentPopup}
        contentId={contentId}
        contentPopupOpen={contentPopupOpen}
      />
    </div>
  ) : null;
};

export default Content;
